/*
  KP: "Product / Bundles" tabs on phone case pages (products with a Model and a Case
  Type option).

  THE BUNDLES THEMSELVES (what is in each, names, discounts) ARE IN
  assets/kp-bundles-config.js. That is the file to edit to add or change a bundle; it
  also explains every setting and how the discounts work. This file only draws them.

  Two tabs sit above the model picker, under the review stars: "Product" (the page as it
  always was) and "Bundles", which carries a badge such as "Up to 15% off" while a bundle
  has a discount. The number is the biggest discount among the bundles on offer for the
  case being looked at, so it follows the bundle list by itself. (The words are
  TAB_PRODUCT, TAB_BUNDLES and TAB_BADGE below.) With "Bundles" on, the picker, Add to
  Cart and the accessories panel step aside and the list of bundles shows right under the
  tabs; the shopper picks one and presses "Add bundle to cart", which puts every item of
  it in the cart together. A bundle with a discount has its items marked and its discount
  code put on the cart (codes already on the cart are kept, so two different bundles in
  one cart both keep their discount).

  BUILD YOUR OWN: one kind of bundle (marked "build" in the bundle list) is not a fixed
  set. It shows the case, then every matching item for that case (the case's
  complementary products) with a round tick box each. The shopper ticks the ones they
  want; once the case and the ticked items together reach the bundle's minimum (3), the
  discount shows on all of them and the button becomes "Add bundle to cart". Until then
  the button says how many more to pick and does nothing.

  With "Product" on, an outline runs from the tabs down around the picker and the buy
  area (to the "Tax included" line), so the tabs and what they hold read as one box. The
  theme's blocks are not moved for this: each one is only marked, and the styles draw the
  sides of the box beside it. Set FRAME to false below to switch the outline off.

  Each item has a "..." button that opens a small dropdown to change it. On the case, that
  changes the phone model (and the case type, where the bundle does not fix it): it sets
  the page's own picker, so the "Product" tab shows the same choice afterwards.
  Names, photos and prices are read from the store when the page opens. If no bundle can
  be made for a case, the tabs do not show at all.

  CASE + CASE (16 Oct 2026, Sana: "on bundles tab add a case+case option", "should allow
  person to select any second case"): a bundle marked "pair" in the bundle list is this case
  plus a second case of ANY design. It starts on the best-selling design (that is not this
  one), in the same phone model and case type; its "..." opens a search box and a grid of
  every phone case design (best sellers first) and a case type choice for the second case.
  There is no code: the store's own Buy 1 Get 1 Half Price takes half off the cheaper of the
  two at checkout, and the card shows it the same way (the cheaper case at half price,
  rounded as the checkout does it).

  Styles: assets/kp-bundles.css (the case + case grid's own styles are at the bottom of this
  file). Loaded by snippets/theme-globals.liquid.
*/
(function () {
  var API = '/api/2025-07/graphql.json';
  var MONEY_TOKEN = /\{\{\s*(\w+)\s*\}\}/;
  var MAGSAFE_TYPE = 'Magsafe Tough Case';
  // The words on the two tabs.
  var TAB_PRODUCT = 'Product';
  var TAB_BUNDLES = 'Bundles';
  // The badge beside "Bundles". {percent} becomes the biggest discount on offer (15 in
  // "Up to 15% off"). Write it without {percent} for fixed words ("Best Deals"), or
  // leave it empty for no badge.
  var TAB_BADGE = 'Up to {percent}% off';
  // The outline around the picker and buy area under the first tab.
  var FRAME = true;
  var ADD_LABEL = 'Add bundle to cart';
  var ADDED_LABEL = '✓ Added';
  var FAILED_LABEL = 'Try again';

  // The list of bundles: assets/kp-bundles-config.js.
  var BUNDLES = window.KP_BUNDLES || [];
  if (!BUNDLES.length) return;

  var PRODUCT_FIELDS = ' { handle title featuredImage { url(transform: { maxWidth: 200 }) } variants(first: 250) { nodes { id title availableForSale price { amount } image { url(transform: { maxWidth: 200 }) } selectedOptions { name value } } } }';
  var VARIANT_FIELDS = ' { id availableForSale price { amount } image { url(transform: { maxWidth: 200 }) } }';

  function each(list, fn) {
    Array.prototype.forEach.call(list, fn);
  }

  function el(tag, className, text) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function withSeparators(value, decimals, thousands, decimal) {
    var parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.join(decimal);
  }

  function money(amount) {
    var format = window.theme && window.theme.moneyFormat;
    var value = parseFloat(amount);

    if (!format || isNaN(value) || !MONEY_TOKEN.test(format)) return '';

    return format.replace(MONEY_TOKEN, function (match, type) {
      switch (type) {
        case 'amount_no_decimals':
          return withSeparators(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withSeparators(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withSeparators(value, 0, '.', ',');
        default:
          return withSeparators(value, 2, ',', '.');
      }
    });
  }

  function numberOf(thing) {
    return thing.id.split('/').pop();
  }

  // The page's own (hidden) select for one option.
  function pageSelect(wrapper, name) {
    var found = null;

    each(wrapper.querySelectorAll('select[name^="options["]'), function (select) {
      if (select.name === 'options[' + name + ']') found = select;
    });

    return found;
  }

  // The choices made on the product, read from the theme's own selects: { name: value }.
  function choicesOf(wrapper) {
    var map = {};

    each(wrapper.querySelectorAll('select[name^="options["]'), function (select) {
      var match = select.name.match(/^options\[(.+)\]$/);
      if (match) map[match[1]] = select.value;
    });

    return map;
  }

  function ask(query, handle) {
    return fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: query, variables: { h: handle, c: (window.Shopify && window.Shopify.country) || null } })
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (json) {
        return (json && json.data) || null;
      })
      .catch(function () {
        return null;
      });
  }

  // Short names for the matching items: the words every one of them starts with (the
  // design's name, "Cherry Matcha") are dropped, leaving "Magnetic Ring Holder",
  // "iPad Case" and so on. { handle: short name }
  function shortNames(recs) {
    var words = recs.map(function (rec) {
      return rec.title.split(' ');
    });
    var shared = 0;
    var same = words.length > 1;

    while (same) {
      var word = words[0][shared];
      if (word === undefined) break;

      for (var i = 1; i < words.length; i++) {
        if (words[i][shared] !== word) same = false;
      }

      if (same) shared += 1;
    }

    var names = {};
    recs.forEach(function (rec, n) {
      names[rec.handle] = words[n].slice(shared).join(' ') || rec.title;
    });

    return names;
  }

  // The case's complementary products and the fixed products, asked for once per page.
  function loadShared(handle) {
    var fixed = [];

    BUNDLES.forEach(function (bundle) {
      (bundle.items || []).concat(bundle.itemsWithoutMagsafe || []).forEach(function (item) {
        if (item.handle && fixed.indexOf(item.handle) < 0) fixed.push(item.handle);
      });
    });

    var query = 'query ($h: String!, $c: CountryCode) @inContext(country: $c) { recs: productRecommendations(productHandle: $h, intent: COMPLEMENTARY)' + PRODUCT_FIELDS + fixed.map(function (name, n) {
      return ' f' + n + ': product(handle: ' + JSON.stringify(name) + ')' + PRODUCT_FIELDS;
    }).join('') + ' }';

    return ask(query, handle).then(function (data) {
      var shared = { recs: (data && data.recs) || [], byHandle: {} };
      shared.names = shortNames(shared.recs);

      fixed.forEach(function (name, n) {
        shared.byHandle[name] = data ? data['f' + n] : null;
      });

      return shared;
    });
  }

  // The case itself in the chosen model: as chosen on the page, and in the MagSafe case
  // type and each other case type a bundle insists on.
  // { productId, cur: variant, forced: { 'Magsafe Tough Case': variant or null } }
  function loadCase(handle, model, type, cache) {
    var key = model + '|' + type;
    if (cache[key]) return Promise.resolve(cache[key]);

    var forced = [MAGSAFE_TYPE];
    BUNDLES.forEach(function (bundle) {
      if (bundle.caseType && forced.indexOf(bundle.caseType) < 0) forced.push(bundle.caseType);
    });

    var pick = function (caseType) {
      return 'variantBySelectedOptions(selectedOptions: [{ name: "Model", value: ' + JSON.stringify(model) + ' }, { name: "Case Type", value: ' + JSON.stringify(caseType) + ' }])' + VARIANT_FIELDS;
    };

    var query = 'query ($h: String!, $c: CountryCode) @inContext(country: $c) { p: product(handle: $h) { id cur: ' + pick(type) + forced.map(function (caseType, n) {
      return ' t' + n + ': ' + pick(caseType);
    }).join('') + ' } }';

    return ask(query, handle).then(function (data) {
      var product = data && data.p;
      if (!product) return null;

      var found = { productId: numberOf(product), cur: product.cur || null, forced: {} };
      forced.forEach(function (caseType, n) {
        found.forced[caseType] = product['t' + n] || null;
      });

      cache[key] = found;
      return found;
    });
  }

  // A price after the bundle's discount. Worked out in pence and rounded down, which is
  // how the discount comes out at checkout (15% off 79.99 is 11.99 off, not 12.00).
  function reduced(amount, bundle) {
    var pence = Math.round(parseFloat(amount) * 100);
    if (!bundle.discount) return pence / 100;
    return (pence - Math.floor(pence * bundle.discount.percent / 100)) / 100;
  }

  // What one line costs in a bundle: half price for the cheaper case of a case + case pair
  // (the store's Buy 1 Get 1 Half Price), otherwise the bundle's discount, if any.
  var HALF = { discount: { percent: 50 } };

  function lineNow(line, bundle) {
    if (line.half && bundle !== NO_DEAL) return reduced(line.variant.price.amount, HALF);
    if (bundle && bundle.pair) return parseFloat(line.variant.price.amount);
    return reduced(line.variant.price.amount, bundle);
  }

  // The lines that are really in the bundle: all of them, or, in a build-your-own bundle,
  // the case and whatever has been ticked.
  function chosenOf(lines) {
    return lines.filter(function (line) {
      return !line.pick || line.on;
    });
  }

  // The bundle as far as prices go: a build-your-own bundle that has not reached its
  // minimum yet has no discount.
  var NO_DEAL = {};

  function dealOf(entry) {
    return entry.lines.build && !entry.lines.active ? NO_DEAL : entry.bundle;
  }

  function start(wrapper) {
    if (wrapper.kpBundles) return;

    var first = choicesOf(wrapper);
    if (!first['Model'] || !first['Case Type']) return;

    var blocks = wrapper.closest('.product-blocks');
    var form = blocks ? blocks.querySelector('form[data-product-form]') : null;
    var handle = form ? form.getAttribute('data-product-handle') : '';
    if (!form || !handle) return;

    wrapper.kpBundles = true;

    var state = { mode: 'product', selected: null, editing: null, picks: {}, checks: {}, blocked: false, shared: null, key: '', shown: null, current: null, productId: '', pair: { product: null, variant: null, type: '', model: '', more: false, key: '', query: '', shown: 24 } };
    var hasPair = BUNDLES.some(function (bundle) {
      return !!bundle.pair;
    });
    var cache = {};

    // ---- The tabs and, right under them, the empty bundle list ----

    var bar = el('div', 'kp-bundles kp-bundles--bar');
    bar.hidden = true;

    var tabs = el('div', 'kp-bundles__tabs');
    tabs.setAttribute('role', 'tablist');

    var tabProduct = el('button', 'kp-bundles__tab', TAB_PRODUCT);
    tabProduct.type = 'button';
    tabProduct.setAttribute('role', 'tab');
    tabProduct.setAttribute('data-kp-bundles-tab', 'product');

    var tabBundle = el('button', 'kp-bundles__tab', TAB_BUNDLES);
    tabBundle.type = 'button';
    tabBundle.setAttribute('role', 'tab');
    tabBundle.setAttribute('data-kp-bundles-tab', 'bundle');

    tabs.appendChild(tabProduct);
    tabs.appendChild(tabBundle);
    bar.appendChild(tabs);

    var root = el('div', 'kp-bundles kp-bundles--list');
    root.hidden = true;

    var panel = el('div', 'kp-bundles__panel');
    panel.hidden = true;

    var intro = el('p', 'kp-bundles__intro');
    intro.appendChild(el('strong', '', 'Choose your bundle.'));
    intro.appendChild(el('span', '', 'Everything is added to your cart together.'));
    panel.appendChild(intro);

    var list = el('div', 'kp-bundles__list');
    panel.appendChild(list);

    var saving = el('div', 'kp-bundles__saving');
    saving.hidden = true;
    panel.appendChild(saving);

    var addButton = el('button', 'kp-bundles__add btn btn--medium btn--full btn--secondary');
    addButton.type = 'button';
    var addLabel = el('span', 'kp-bundles__add-label', ADD_LABEL);
    addButton.appendChild(addLabel);
    panel.appendChild(addButton);

    root.appendChild(panel);

    // Under Add to Cart on the Product tab: a line that opens Case + case with the design
    // picker showing (16 Oct 2026, Sana). Only while a case + case bundle can be made.
    // (In a box of its own, so it takes the full width and the outline around the buy area
    // runs past it like the blocks around it.)
    var nudgeBox = el('div', 'kp-bundles-nudge-box');
    nudgeBox.hidden = true;
    var nudge = el('button', 'kp-bundles-nudge');
    nudge.type = 'button';
    nudgeBox.appendChild(nudge);
    var nudgeText = el('span', 'kp-bundles-nudge__text');
    nudgeText.appendChild(el('strong', '', 'Add a 2nd case, half price'));
    var nudgeSub = el('span', 'kp-bundles-nudge__sub', 'Any design');
    nudgeText.appendChild(nudgeSub);
    nudge.appendChild(nudgeText);
    nudge.appendChild(el('span', 'kp-bundles-nudge__arrow', '→'));
    nudge.setAttribute('aria-expanded', 'false');

    // CASE + CASE UNDER ADD TO CART (16 Oct 2026, Sana): pressing the line opens the 2nd case
    // picker right here (every design, search, and the 2nd case's phone and case type), with
    // one button that adds this case and the 2nd case together. Case + case is no longer a
    // card in the Bundles tab (it is marked "inline" in assets/kp-bundles-config.js). The
    // store's Buy 1 Get 1 Half Price takes half off the cheaper case at checkout.
    var pairBox = el('div', 'kp-bundles kp-bundles-pairbox');
    pairBox.hidden = true;
    var pairItem = el('div', 'kp-bundles__items');
    pairBox.appendChild(pairItem);
    var pairAdd = el('button', 'kp-bundles__add btn btn--medium btn--full btn--secondary');
    pairAdd.type = 'button';
    pairAdd.setAttribute('data-kp-bundles-pairadd', '');
    var pairAddLabel = el('span', 'kp-bundles__add-label', 'Add both to cart');
    pairAdd.appendChild(pairAddLabel);
    pairBox.appendChild(pairAdd);
    nudgeBox.appendChild(pairBox);
    var pairOpen = false;

    // The block holding Add to Cart, among the picker's neighbours.
    function formBlock() {
      var node = form;
      while (node && node.parentNode !== wrapper.parentNode) node = node.parentNode;
      return node;
    }

    // The outline under the first tab: mark every block from the picker down to the
    // "Tax included" line (or Add to Cart, if there is no such line). Nothing is moved;
    // the styles draw the sides of the box beside each marked block.
    function frame() {
      each(blocks.querySelectorAll('.kp-bundles-in'), function (node) {
        node.classList.remove('kp-bundles-in', 'kp-bundles-in--first', 'kp-bundles-in--last');
      });
      bar.classList.remove('is-framed');

      if (!FRAME || bar.hidden) return;

      var last = blocks.querySelector('.product__policies');
      if (!last || last.parentNode !== wrapper.parentNode) last = form;
      // Only if that block really is a later sibling of the picker.
      if (last.parentNode !== wrapper.parentNode || !(wrapper.compareDocumentPosition(last) & 4)) return;

      var node = wrapper;
      while (node) {
        node.classList.add('kp-bundles-in');
        if (node === wrapper) node.classList.add('kp-bundles-in--first');
        if (node === last) {
          node.classList.add('kp-bundles-in--last');
          break;
        }
        node = node.nextElementSibling;
      }

      bar.classList.add('is-framed');
    }

    // Tabs, then the bundle list, then the picker (so the tabs sit under the review
    // stars). Checked again on every update, in case the theme re-draws that part.
    function place() {
      if (!(root.parentNode === wrapper.parentNode && root.nextElementSibling === wrapper)) {
        wrapper.parentNode.insertBefore(root, wrapper);
      }

      if (!(bar.parentNode === root.parentNode && bar.nextElementSibling === root)) {
        root.parentNode.insertBefore(bar, root);
      }

      var buy = formBlock();
      if (buy && !(nudgeBox.parentNode === buy.parentNode && buy.nextElementSibling === nudgeBox)) {
        buy.parentNode.insertBefore(nudgeBox, buy.nextSibling);
      }

      frame();
    }

    // Open or close the 2nd case picker under the line.
    function openPair() {
      pairOpen = !pairOpen;
      nudge.classList.toggle('is-open', pairOpen);
      nudge.setAttribute('aria-expanded', pairOpen ? 'true' : 'false');
      if (pairOpen) state.editing = 'pair:second';
      drawPair();
    }

    function pairEntryOf() {
      return (state.shown || []).filter(function (entry) {
        return entry.bundle.pair;
      })[0] || null;
    }

    // The picker under the line: the 2nd case (with its design grid) and the button.
    function drawPair() {
      pairBox.hidden = !pairOpen;
      if (!pairOpen) return;

      var entry = pairEntryOf();
      pairItem.innerHTML = '';
      if (!entry) {
        pairItem.appendChild(el('p', 'kp-bundles__intro kp-bundles__loading', 'Loading designs…'));
        pairAdd.style.display = 'none';
        return;
      }

      var second = entry.lines.filter(function (line) {
        return line.pairPick;
      })[0];
      pairItem.appendChild(drawItem(second, entry.bundle));

      var missing = !!entry.lines.missing;
      pairAdd.style.display = '';
      pairAdd.classList.toggle('is-blocked', missing);
      pairAdd.setAttribute('aria-disabled', missing ? 'true' : 'false');
      if (!pairAdd.disabled) pairAddLabel.textContent = missing ? 'Pick another 2nd case' : 'Add both to cart · ' + money(payOf(entry.lines, entry.bundle));
    }

    // Both cases into the cart together (no code: Buy 1 Get 1 Half Price is automatic).
    function addPair() {
      var entry = pairEntryOf();
      if (!entry || entry.lines.missing || pairAdd.disabled) return;

      var items = entry.lines.map(function (line) {
        return { id: parseInt(numberOf(line.variant), 10), quantity: 1 };
      });
      var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      pairAdd.disabled = true;

      var done = function (ok) {
        pairAddLabel.textContent = ok ? ADDED_LABEL : FAILED_LABEL;
        if (ok) announce();

        window.setTimeout(function () {
          pairAdd.disabled = false;
          drawPair();
        }, ok ? 1800 : 1500);
      };

      fetch(rootUrl + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        done(response.ok);
      }, function () {
        done(false);
      });
    }

    function setMode(mode) {
      var on = mode === 'bundle';

      state.mode = mode;
      tabProduct.setAttribute('aria-selected', on ? 'false' : 'true');
      tabBundle.setAttribute('aria-selected', on ? 'true' : 'false');
      panel.hidden = !on;
      bar.classList.toggle('is-open', on);
      // The styles hide the picker, the "Double-check" note, Add to Cart, Shop Pay and the
      // accessories panel while these are on.
      wrapper.classList.toggle('kp-bundles-hide', on);
      blocks.classList.toggle('kp-bundle-mode', on);
      if (on && !state.shown) waiting();
    }

    // SPEED / NO JUMP (16 Oct 2026, Sana: on phones the tabs "don't load immediately" and the
    // page jumps): the tabs, the outline and the "Add a 2nd case" line are put on the page as
    // soon as this script runs, not after the bundles have been worked out (that needs a
    // trip to Shopify). The space they take is also held from the very first paint by a
    // style in snippets/kp-extras.liquid (part 14), so nothing moves when they appear. If
    // Bundles is pressed before the bundles are ready, the box says "Loading bundles..."
    // until they are.
    function waiting() {
      root.hidden = false;
      if (list.querySelector('.kp-bundles__card')) return;
      list.innerHTML = '';
      list.appendChild(el('p', 'kp-bundles__intro kp-bundles__loading', 'Loading bundles…'));
      addButton.style.display = 'none';
      saving.hidden = true;
    }

    // The Bundles tab: the word, and its badge while a bundle on offer has a discount.
    // The badge's number is the biggest discount among the bundles on offer.
    // Case + case has no "discount": its percent is what the pair really saves (half of one
    // case is 25% off two cases of the same price), worked out from its prices.
    function labelTab(shown) {
      var best = 0;
      shown.forEach(function (entry) {
        var percent = entry.bundle.discount ? entry.bundle.discount.percent : 0;
        if (entry.bundle.pair && !entry.lines.missing) {
          var full = totalOf(entry.lines);
          if (full > 0) percent = Math.round((full - payOf(entry.lines, entry.bundle)) / full * 100);
        }
        if (percent > best) best = percent;
      });

      tabBundle.textContent = TAB_BUNDLES;
      if (best && TAB_BADGE) tabBundle.appendChild(el('span', 'kp-bundles__deal', TAB_BADGE.replace('{percent}', best)));
    }

    // Change the model or case type from inside a bundle: set the page's own select and
    // let the theme (and our picker) carry on from there, as if it had been chosen above.
    function setChoice(name, value) {
      var select = pageSelect(wrapper, name);
      if (!select || select.value === value) return;

      select.value = value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
    }

    // ---- Working out what is in each bundle ----

    // The product for one item: the case's complementary product of that kind, or else
    // (or only) the fixed product named by its handle.
    function productFor(item) {
      var product = null;

      if (item.match) {
        product = state.shared.recs.filter(function (rec) {
          return rec.title.toLowerCase().indexOf(item.match.toLowerCase()) > -1;
        })[0];
      }

      if (!product && item.handle) product = state.shared.byHandle[item.handle];

      return product || null;
    }

    // The first line of every bundle: the case.
    function caseLine(bundle, choices, variant, caseType, fixedType) {
      return {
        label: choices['Model'] + ' Case',
        tag: 'This item',
        note: caseType,
        key: bundle.id + ':case',
        sets: fixedType ? ['Model'] : ['Model', 'Case Type'],
        variant: variant,
        image: variant.image ? variant.image.url : ''
      };
    }

    // A build-your-own bundle: the case as chosen on the page, then every matching item
    // (the case's complementary products) to tick. Null if there are too few to reach
    // the bundle's minimum.
    function buildLines(bundle, choices, found) {
      var caseVariant = found.cur;
      if (!caseVariant || !caseVariant.availableForSale) return null;

      var min = bundle.build.min || 3;
      var lines = [caseLine(bundle, choices, caseVariant, choices['Case Type'], false)];

      state.shared.recs.forEach(function (product) {
        var variants = product.variants.nodes.filter(function (variant) {
          return variant.availableForSale;
        });
        if (!variants.length) return;

        var key = bundle.id + ':p:' + product.handle;
        var chosen = variants.filter(function (variant) {
          return numberOf(variant) === state.picks[key];
        })[0] || variants[0];
        state.picks[key] = numberOf(chosen);

        lines.push({
          label: state.shared.names[product.handle] || product.title,
          key: key,
          variants: variants,
          variant: chosen,
          image: (chosen.image && chosen.image.url) || (product.featuredImage && product.featuredImage.url) || '',
          pick: true,
          on: !!state.checks[key]
        });
      });

      // Not enough matching items to ever reach the minimum: no such bundle for this case.
      if (lines.length < min) return null;

      lines.build = true;
      lines.min = min;
      lines.count = chosenOf(lines).length;
      lines.active = lines.count >= min;

      return lines;
    }

    // Case + case: this case as chosen on the page, then the second case (any design, see
    // ensurePair). The cheaper of the two is marked half price.
    function pairLines(bundle, choices, found) {
      var caseVariant = found.cur;
      if (!caseVariant || !caseVariant.availableForSale) return null;

      var second = state.pair;
      if (!second.product) return null;

      var type = second.type || choices['Case Type'];
      var model = second.model || choices['Model'];
      var lines = [caseLine(bundle, choices, caseVariant, choices['Case Type'], false)];
      var other = {
        label: designOf(second.product.title),
        tag: '2nd case',
        // The phone is always named, so there is no doubt which phone the 2nd case fits.
        note: second.variant ? model + ' · ' + type : 'Not made for ' + model + ' as a ' + type + '. Pick another design, phone or case type.',
        key: 'pair:second',
        pairPick: true,
        variant: second.variant || caseVariant,
        missing: !second.variant,
        image: second.variant && second.variant.image ? second.variant.image.url : second.product.image || ''
      };
      lines.push(other);

      if (!other.missing) {
        var a = parseFloat(lines[0].variant.price.amount);
        var b = parseFloat(other.variant.price.amount);
        (b <= a ? other : lines[0]).half = true;
      }

      lines.pair = true;
      lines.missing = other.missing;
      return lines;
    }

    // The lines of one bundle for the choices made on the page, or null if it cannot be made.
    function linesOf(bundle, choices, found) {
      if (bundle.build) return buildLines(bundle, choices, found);
      if (bundle.pair) return pairLines(bundle, choices, found);

      // The case type the bundle asks for, when the model comes in it. Otherwise the case
      // as chosen on the page, if the bundle allows that (or asks for nothing).
      var asked = bundle.caseType ? found.forced[bundle.caseType] : null;
      var caseVariant = asked || (!bundle.caseType || bundle.caseFallback ? found.cur : null);
      if (!caseVariant || !caseVariant.availableForSale) return null;

      var caseType = asked ? bundle.caseType : choices['Case Type'];
      var magsafe = caseType === MAGSAFE_TYPE;

      // A model that does not come in a MagSafe case at all can have its own set of items.
      var other = !found.forced[MAGSAFE_TYPE] && !!bundle.itemsWithoutMagsafe;
      var wantedItems = other ? bundle.itemsWithoutMagsafe : bundle.items;

      var lines = [caseLine(bundle, choices, caseVariant, caseType, !!asked)];

      // Remembered for the card's description (see draw).
      lines.withoutMagsafe = !magsafe;
      lines.otherItems = other;

      for (var i = 0; i < wantedItems.length; i++) {
        var item = wantedItems[i];
        var product = productFor(item);

        if (!product) return null;

        var variants = product.variants.nodes.filter(function (variant) {
          return variant.availableForSale;
        });

        if (item.follow) {
          variants = variants.filter(function (variant) {
            return variant.selectedOptions.some(function (option) {
              return option.name === item.follow && option.value === choices[item.follow];
            });
          });
        }

        if (!variants.length) return null;

        // Which option to start on can depend on whether the case is a MagSafe one, so the
        // shopper's own choice is remembered separately for each (and for each set of items).
        var wanted = (!magsafe && item.preferWithoutMagsafe) || item.prefer;
        var key = bundle.id + ':' + (other ? 'x' : '') + i + (item.preferWithoutMagsafe ? (magsafe ? ':m' : ':n') : '');
        var chosen = variants.filter(function (variant) {
          return numberOf(variant) === state.picks[key];
        })[0];

        if (!chosen) {
          chosen = variants.filter(function (variant) {
            return wanted && variant.title === wanted;
          })[0] || variants[0];
          state.picks[key] = numberOf(chosen);
        }

        lines.push({
          label: item.label || product.title,
          key: key,
          follow: item.follow,
          variants: variants,
          variant: chosen,
          image: (chosen.image && chosen.image.url) || (product.featuredImage && product.featuredImage.url) || ''
        });
      }

      return lines;
    }

    // The line under a bundle's title, for the items it has ended up with.
    function textOf(entry) {
      return (entry.lines.otherItems && entry.bundle.textModelWithoutMagsafe) || (entry.lines.withoutMagsafe && entry.bundle.textWithoutMagsafe) || entry.bundle.text;
    }

    // Full price of what is in a bundle, and what is paid for it after its discount.
    function totalOf(lines) {
      return chosenOf(lines).reduce(function (sum, line) {
        return sum + Math.round(parseFloat(line.variant.price.amount) * 100);
      }, 0) / 100;
    }

    function payOf(lines, bundle) {
      return chosenOf(lines).reduce(function (sum, line) {
        return sum + Math.round(lineNow(line, bundle) * 100);
      }, 0) / 100;
    }

    // "was" price struck through, then the price now. Just the price when they are the same.
    function priceHtml(was, now) {
      if (now < was) return '<s>' + money(was) + '</s> <span class="kp-bundles__now">' + money(now) + '</span>';
      return money(was);
    }

    // ---- Drawing ----

    function photo(className, src, size) {
      var image = el('img', className);
      image.alt = '';
      image.width = size;
      image.height = size;
      if (src) image.src = src;
      return image;
    }

    // A dropdown that sets the page's own Model or Case Type.
    function pageDropdown(name) {
      var source = pageSelect(wrapper, name);
      if (!source) return null;

      var select = el('select', 'kp-bundles__select');
      select.setAttribute('data-kp-bundles-set', name);
      select.setAttribute('aria-label', name);

      each(source.options, function (from) {
        var option = el('option', '', from.value);
        option.value = from.value;
        if (from.value === source.value) option.selected = true;
        select.appendChild(option);
      });

      return select;
    }

    // One item of the open bundle: photo, name, what kind, price, and "..." to change it.
    // An item to tick (build your own) also has a round tick box in front; its photo
    // ticks it too.
    function drawItem(line, bundle) {
      var row = el('div', 'kp-bundles__item' + (line.pick ? ' kp-bundles__item--pick' + (line.on ? ' is-on' : '') : ''));
      var picture = photo('kp-bundles__image', line.image, line.pick ? 56 : 72);

      if (line.pick) {
        var check = el('button', 'kp-bundles__check');
        check.type = 'button';
        check.setAttribute('data-kp-bundles-toggle', line.key);
        check.setAttribute('role', 'checkbox');
        check.setAttribute('aria-checked', line.on ? 'true' : 'false');
        check.setAttribute('aria-label', line.label);
        row.appendChild(check);
        picture.setAttribute('data-kp-bundles-toggle', line.key);
      }

      row.appendChild(picture);

      var body = el('div', 'kp-bundles__body');
      var name = el('div', 'kp-bundles__item-name', line.label);
      if (line.tag) name.appendChild(el('span', 'kp-bundles__tag', line.tag));
      body.appendChild(name);

      var canChange = !!line.sets || !!line.pairPick || (line.variants && line.variants.length > 1 && !line.follow);
      var editing = canChange && state.editing === line.key;

      if (line.pairPick) {
        body.appendChild(el('div', 'kp-bundles__note' + (line.missing ? ' kp-bundles__note--warn' : ''), line.note));
      } else if (editing && line.sets) {
        // The case: the page's own Model (and Case Type) choices.
        line.sets.forEach(function (optionName) {
          var dropdown = pageDropdown(optionName);
          if (dropdown) body.appendChild(dropdown);
        });
      } else if (editing) {
        var select = el('select', 'kp-bundles__select');
        select.setAttribute('data-kp-bundles-pick', line.key);
        select.setAttribute('aria-label', line.label);

        line.variants.forEach(function (variant) {
          var option = el('option', '', variant.title);
          option.value = numberOf(variant);
          if (variant === line.variant) option.selected = true;
          select.appendChild(option);
        });

        body.appendChild(select);
      } else {
        var note = line.note || (line.variant.title && line.variant.title !== 'Default Title' ? line.variant.title : '');
        if (note) body.appendChild(el('div', 'kp-bundles__note', note));
      }

      // An item that is not ticked shows its plain price.
      var deal = line.pick && !line.on ? NO_DEAL : bundle;
      if (!line.missing) {
        var price = el('div', 'kp-bundles__item-price');
        price.innerHTML = priceHtml(parseFloat(line.variant.price.amount), lineNow(line, deal)) + (line.half ? ' <span class="kp-bundles__half">Half price</span>' : '');
        body.appendChild(price);
      }
      row.appendChild(body);

      if (canChange) {
        var more = el('button', 'kp-bundles__more', line.pairPick ? 'Change' : '•••');
        if (line.pairPick) more.className += ' kp-bundles__more--word';
        more.type = 'button';
        more.setAttribute('data-kp-bundles-edit', line.key);
        more.setAttribute('aria-label', 'Change ' + line.label);
        row.appendChild(more);
      }

      if (line.pairPick && (editing || line.missing)) {
        var wrap = el('div', 'kp-bundles__pairbox');
        wrap.appendChild(row);
        wrap.appendChild(pairPanel());
        return wrap;
      }

      return row;
    }

    // ---- Case + case: choosing the second case ----

    var designs = null;

    // Every phone case design, best sellers first (only the names and photos; the case
    // itself is asked for once one is picked). This case's own design is left out.
    function loadDesigns() {
      if (designs) return designs;
      var all = [];
      var page = function (after) {
        var query = 'query ($h: String!, $a: String, $c: CountryCode) @inContext(country: $c) { col: collection(handle: $h) { products(first: 250, after: $a, sortKey: BEST_SELLING) { pageInfo { hasNextPage endCursor } nodes { handle title availableForSale featuredImage { url(transform: { maxWidth: 240 }) } } } } }';
        return fetch(API, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ query: query, variables: { h: 'phone-cases', a: after || null, c: (window.Shopify && window.Shopify.country) || null } })
        })
          .then(function (response) {
            return response.json();
          })
          .then(function (json) {
            var block = json && json.data && json.data.col && json.data.col.products;
            if (!block) return all;
            block.nodes.forEach(function (product) {
              if (!product.availableForSale || product.handle === handle) return;
              if (!/phone case/i.test(product.title) || /airpods|ipad/i.test(product.title)) return;
              all.push({ handle: product.handle, title: product.title, image: product.featuredImage ? product.featuredImage.url : '' });
            });
            return block.pageInfo.hasNextPage && all.length < 1500 ? page(block.pageInfo.endCursor) : all;
          })
          .catch(function () {
            return all;
          });
      };
      designs = page(null);
      return designs;
    }

    // "Curious Geese Checkered Phone Case" -> "Curious Geese Checkered"
    function designOf(title) {
      return String(title).replace(/\s*(tough\s+)?phone case\s*$/i, '').trim() || title;
    }

    var pairCache = {};

    function loadPairVariant(design, model, type) {
      var key = design + '|' + model + '|' + type;
      if (pairCache[key]) return pairCache[key];
      var query = 'query ($h: String!, $c: CountryCode) @inContext(country: $c) { p: product(handle: $h) { v: variantBySelectedOptions(selectedOptions: [{ name: "Model", value: ' + JSON.stringify(model) + ' }, { name: "Case Type", value: ' + JSON.stringify(type) + ' }])' + VARIANT_FIELDS + ' } }';
      pairCache[key] = ask(query, design).then(function (data) {
        return data && data.p ? data.p.v : null;
      });
      return pairCache[key];
    }

    // Makes sure the second case is known for the model and case type now chosen: the
    // design picked (or the best seller to start with) in that model and case type.
    function ensurePair(choices) {
      if (!hasPair) return Promise.resolve();
      return loadDesigns().then(function (list) {
        if (!state.pair.product) state.pair.product = list[0] || null;
        if (!state.pair.product) return null;
        var type = state.pair.type || choices['Case Type'];
        var model = state.pair.model || choices['Model'];
        var key = state.pair.product.handle + '|' + model + '|' + type;
        if (state.pair.key === key) return null;
        return loadPairVariant(state.pair.product.handle, model, type).then(function (variant) {
          state.pair.key = key;
          state.pair.variant = variant && variant.availableForSale ? variant : null;
        });
      });
    }

    // [option value, short word on the button]. The short words keep the three on one line on
    // a phone; the option names themselves are unchanged.
    var PAIR_TYPES = [['Snap Case', 'Snap'], ['Tough Case', 'Tough'], [MAGSAFE_TYPE, 'MagSafe']];

    // The panel under the second case: every design to pick from, and, folded away behind
    // "Different phone or case type?", the second case's phone and case type. (16 Oct 2026,
    // Sana: in the last 250 orders, 72 of 79 two-case orders had the same case type, but 18
    // were for two different phones.) The second case follows the first case's phone and case
    // type until one is chosen here.
    function pairPanel() {
      var panelBox = el('div', 'kp-bundles__pair');
      var current = choicesOf(wrapper);
      var type = state.pair.type || current['Case Type'];
      var model = state.pair.model || current['Model'];
      var open = state.pair.more || !!state.pair.type || !!state.pair.model;

      // A line saying which phone and case type the 2nd case is for, with the link to change
      // them (or, once open, to go back to matching the first case).
      var head = el('div', 'kp-bundles__pair-head');
      var forText = el('span', 'kp-bundles__pair-for');
      forText.appendChild(document.createTextNode('2nd case for '));
      forText.appendChild(el('strong', '', model + ' · ' + type));
      head.appendChild(forText);
      var toggle = el('button', 'kp-bundles__pair-toggle', open ? 'Match my 1st case' : 'Change');
      toggle.type = 'button';
      toggle.setAttribute('data-kp-bundles-pairopts', open ? 'reset' : 'open');
      toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
      toggle.setAttribute('aria-label', open ? 'Use the same phone and case type as my first case' : 'Choose a different phone or case type for the 2nd case');
      head.appendChild(toggle);
      panelBox.appendChild(head);

      if (open) {
        var opts = el('div', 'kp-bundles__pair-opts');
        var source = pageSelect(wrapper, 'Model');
        if (source) {
          var select = el('select', 'kp-bundles__pair-model');
          select.setAttribute('data-kp-bundles-pairmodel', '');
          select.setAttribute('aria-label', 'Phone for the 2nd case');
          each(source.options, function (from) {
            var option = el('option', '', from.value);
            option.value = from.value;
            if (from.value === model) option.selected = true;
            select.appendChild(option);
          });
          opts.appendChild(select);
        }

        var types = el('div', 'kp-bundles__pair-types');
        PAIR_TYPES.forEach(function (entry) {
          var on = entry[0] === type;
          var pill = el('button', 'kp-bundles__pair-type' + (on ? ' is-on' : ''), entry[1]);
          pill.type = 'button';
          pill.setAttribute('data-kp-bundles-pairtype', entry[0]);
          pill.setAttribute('aria-pressed', on ? 'true' : 'false');
          pill.setAttribute('aria-label', entry[0]);
          types.appendChild(pill);
        });
        opts.appendChild(types);
        panelBox.appendChild(opts);
      }

      var search = el('input', 'kp-bundles__pair-search');
      search.type = 'search';
      search.placeholder = 'Search all designs';
      search.setAttribute('aria-label', 'Search all designs');
      search.setAttribute('data-kp-bundles-pairsearch', '');
      search.value = state.pair.query || '';
      panelBox.appendChild(search);

      var grid = el('div', 'kp-bundles__pair-grid');
      panelBox.appendChild(grid);

      var more = el('button', 'kp-bundles__pair-more', 'Show more designs');
      more.type = 'button';
      more.setAttribute('data-kp-bundles-pairmore', '');
      panelBox.appendChild(more);

      loadDesigns().then(function (list) {
        fillGrid(panelBox, list);
      });

      return panelBox;
    }

    function fillGrid(panelBox, list) {
      var grid = panelBox.querySelector('.kp-bundles__pair-grid');
      var more = panelBox.querySelector('.kp-bundles__pair-more');
      if (!grid) return;

      var words = (state.pair.query || '').toLowerCase().split(/\s+/).filter(Boolean);
      var hits = list.filter(function (design) {
        var name = design.title.toLowerCase();
        return words.every(function (word) {
          return name.indexOf(word) > -1;
        });
      });

      grid.innerHTML = '';
      hits.slice(0, state.pair.shown).forEach(function (design) {
        var on = state.pair.product && state.pair.product.handle === design.handle;
        var tile = el('button', 'kp-bundles__pair-tile' + (on ? ' is-on' : ''));
        tile.type = 'button';
        tile.setAttribute('data-kp-bundles-design', design.handle);
        tile.setAttribute('aria-pressed', on ? 'true' : 'false');
        var image = photo('kp-bundles__pair-image', design.image, 120);
        image.loading = 'lazy';
        tile.appendChild(image);
        tile.appendChild(el('span', 'kp-bundles__pair-name', designOf(design.title)));
        grid.appendChild(tile);
      });

      if (!hits.length) grid.appendChild(el('p', 'kp-bundles__pair-empty', 'No designs found'));
      more.hidden = hits.length <= state.pair.shown;
    }

    function draw() {
      var all = state.shown || [];
      // The Bundles tab leaves out bundles marked "inline" (Case + case, which opens under
      // Add to Cart instead).
      var shown = all.filter(function (entry) {
        return !entry.bundle.inline;
      });

      // The line under Add to Cart: only while Case + case can be made, with the price of a
      // half-price second case (the cheaper case of the pair, as the checkout rounds it).
      var pairEntry = all.filter(function (entry) {
        return entry.bundle.pair && !entry.lines.missing;
      })[0];
      // While the picker is open it stays open, even if the 2nd case chosen is not made for
      // that phone and case type (the shopper is still choosing).
      var pairAny = all.some(function (entry) {
        return entry.bundle.pair;
      });
      if (!pairAny) pairOpen = false;
      nudgeBox.hidden = !(pairEntry || (pairOpen && pairAny));
      if (pairEntry) {
        var halfLine = pairEntry.lines.filter(function (line) {
          return line.half;
        })[0];
        nudgeSub.textContent = 'Any design' + (halfLine ? ' · ' + money(reduced(halfLine.variant.price.amount, HALF)) : '');
      }
      drawPair();

      if (!shown.length) {
        bar.hidden = true;
        root.hidden = true;
        setMode('product');
        frame();
        return;
      }

      var ids = shown.map(function (entry) {
        return entry.bundle.id;
      });
      if (ids.indexOf(state.selected) < 0) state.selected = ids[0];

      labelTab(shown);
      list.innerHTML = '';
      state.current = null;
      addButton.style.display = '';

      shown.forEach(function (entry) {
        var on = entry.bundle.id === state.selected;
        var deal = dealOf(entry);
        var card = el('div', 'kp-bundles__card' + (on ? ' is-selected' : ''));

        // {save} in a badge becomes what the bundle saves now ("Save {save}" -> "Save £22.32").
        if (entry.bundle.badge) {
          var badgeText = entry.bundle.badge;
          if (badgeText.indexOf('{save}') > -1) {
            var saved = totalOf(entry.lines) - payOf(entry.lines, deal);
            badgeText = saved > 0 ? badgeText.replace('{save}', money(saved)) : '';
          }
          if (badgeText) card.appendChild(el('div', 'kp-bundles__badge', badgeText));
        }

        var head = el('button', 'kp-bundles__head');
        head.type = 'button';
        head.setAttribute('data-kp-bundles-choose', entry.bundle.id);
        head.setAttribute('aria-pressed', on ? 'true' : 'false');
        head.appendChild(el('span', 'kp-bundles__radio'));

        var titles = el('span', 'kp-bundles__titles');
        var name = el('span', 'kp-bundles__name', entry.bundle.name);
        if (entry.bundle.discount) name.appendChild(el('span', 'kp-bundles__off', entry.bundle.discount.percent + '% off'));
        else if (entry.bundle.tag) name.appendChild(el('span', 'kp-bundles__off', entry.bundle.tag));
        titles.appendChild(name);
        titles.appendChild(el('span', 'kp-bundles__desc', textOf(entry)));
        head.appendChild(titles);

        // A build-your-own bundle has no total to show until something has been ticked.
        if ((!entry.lines.build || entry.lines.count > 1) && !entry.lines.missing) {
          var total = el('span', 'kp-bundles__total');
          total.innerHTML = priceHtml(totalOf(entry.lines), payOf(entry.lines, deal));
          head.appendChild(total);
        }

        card.appendChild(head);

        if (on) {
          // Open: every item in full, with a plus sign between them. In a build-your-own
          // bundle the case comes first, then the items to tick under a short heading.
          var items = el('div', 'kp-bundles__items');
          entry.lines.forEach(function (line, n) {
            if (entry.lines.build) {
              if (n === 1) items.appendChild(el('div', 'kp-bundles__pick-title', 'Tick ' + (entry.lines.min - 1) + ' or more to go with it'));
            } else if (n) {
              items.appendChild(el('div', 'kp-bundles__plus', '+'));
            }
            items.appendChild(drawItem(line, deal));
          });
          card.appendChild(items);
          state.current = entry;
        } else {
          // Closed: just the photos in a row; pressing them chooses the bundle too. (At
          // most five, so a long list of matching items stays on one line.)
          var thumbs = el('div', 'kp-bundles__thumbs');
          thumbs.setAttribute('data-kp-bundles-choose', entry.bundle.id);
          entry.lines.slice(0, 5).forEach(function (line, n) {
            if (n && !entry.lines.build) thumbs.appendChild(el('span', 'kp-bundles__thumb-plus', '+'));
            thumbs.appendChild(photo('kp-bundles__thumb', line.image, 52));
          });
          card.appendChild(thumbs);
        }

        list.appendChild(card);
      });

      if (state.current) {
        var lines = state.current.lines;
        var was = totalOf(lines);
        var pay = payOf(lines, dealOf(state.current));
        var short = lines.build && !lines.active ? lines.min - lines.count : 0;

        state.blocked = short > 0 || !!lines.missing;
        addButton.classList.toggle('is-blocked', state.blocked);
        addButton.setAttribute('aria-disabled', state.blocked ? 'true' : 'false');
        saving.classList.toggle('kp-bundles__saving--hint', state.blocked);

        if (lines.missing) {
          // Case + case: the second case does not come in this phone and case type.
          saving.hidden = true;
          if (!addButton.disabled) addLabel.textContent = 'Pick another 2nd case';
        } else if (state.blocked) {
          // Build your own, not enough ticked yet.
          saving.hidden = false;
          saving.innerHTML = 'Tick <strong>' + short + ' more</strong> to get ' + state.current.bundle.discount.percent + '% off everything';
          if (!addButton.disabled) addLabel.textContent = 'Tick ' + short + ' more to save ' + state.current.bundle.discount.percent + '%';
        } else {
          saving.hidden = !(pay < was);
          if (pay < was) saving.innerHTML = 'You’re saving <strong>' + money(was - pay) + '</strong> with this bundle';
          if (!addButton.disabled) addLabel.innerHTML = ADD_LABEL + ' · ' + money(pay);
        }
      }

      bar.hidden = false;
      root.hidden = false;
      frame();
    }

    // Work the bundles out again for the model and case type now chosen on the page.
    function update(force) {
      place();
      if (!state.shared) return;

      var choices = choicesOf(wrapper);
      var key = choices['Model'] + '|' + choices['Case Type'];
      if (!force && key === state.key) return;
      state.key = key;

      Promise.all([loadCase(handle, choices['Model'], choices['Case Type'], cache), ensurePair(choices)]).then(function (both) {
        var found = both[0];
        if (state.key !== key) return;

        state.shown = [];
        if (found) {
          state.productId = found.productId;
          BUNDLES.forEach(function (bundle) {
            var lines = linesOf(bundle, choices, found);
            if (lines) state.shown.push({ bundle: bundle, lines: lines });
          });
        }

        draw();
      });
    }

    // ---- Adding to the cart ----

    function announce() {
      try {
        document.dispatchEvent(new CustomEvent('kp:cart.change'));
      } catch (e) {}

      // Refresh the Rebuy cart and open it, as it opens after the normal Add to Cart.
      try {
        var rebuy = window.Rebuy;
        if (rebuy && rebuy.Cart && typeof rebuy.Cart.fetchCart === 'function') rebuy.Cart.fetchCart();
        if (rebuy && rebuy.SmartCart && typeof rebuy.SmartCart.show === 'function') rebuy.SmartCart.show();
      } catch (e) {}
    }

    // Put the bundle's discount code on the cart, keeping any codes that are already
    // there: the cart is given the whole list, with ours added if it is missing. Failing
    // is harmless (the items are just full price).
    function applyCode(code, root_url) {
      var json = { 'Content-Type': 'application/json', Accept: 'application/json' };

      return fetch(root_url + 'cart.js', { headers: { Accept: 'application/json' } })
        .then(function (response) {
          return response.json();
        })
        .then(function (cart) {
          var codes = ((cart && cart.discount_codes) || []).map(function (entry) {
            return entry.code;
          });
          if (codes.indexOf(code) < 0) codes.push(code);

          return fetch(root_url + 'cart/update.js', {
            method: 'POST',
            headers: json,
            body: JSON.stringify({ discount: codes.join(',') })
          });
        })
        .catch(function () {});
    }

    function add() {
      if (addButton.disabled || state.blocked || !state.current) return;

      var discount = state.current.bundle.discount;
      var marked = discount && state.productId;
      var items = chosenOf(state.current.lines).map(function (line) {
        var entry = { id: parseInt(numberOf(line.variant), 10), quantity: 1 };

        if (marked) {
          entry.properties = {};
          entry.properties[discount.property] = state.productId + '#' + discount.offer;
        }

        return entry;
      });
      var root_url = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      addButton.disabled = true;

      var done = function (ok) {
        addLabel.textContent = ok ? ADDED_LABEL : FAILED_LABEL;
        if (ok) announce();

        window.setTimeout(function () {
          addButton.disabled = false;
          draw();
        }, ok ? 1800 : 1500);
      };

      fetch(root_url + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (response) {
        if (!response.ok || !marked) return response.ok;

        return applyCode(discount.code, root_url).then(function () {
          return true;
        });
      }).then(done, function () {
        done(false);
      });
    }

    // ---- Events ----

    nudge.addEventListener('click', openPair);

    bar.addEventListener('click', function (event) {
      var tab = event.target.closest ? event.target.closest('[data-kp-bundles-tab]') : null;
      if (tab) setMode(tab.getAttribute('data-kp-bundles-tab'));
    });

    function onClick(event) {
      if (!event.target.closest) return;

      if (event.target.closest('[data-kp-bundles-pairadd]')) {
        addPair();
        return;
      }

      var edit = event.target.closest('[data-kp-bundles-edit]');
      if (edit) {
        var key = edit.getAttribute('data-kp-bundles-edit');
        state.editing = state.editing === key ? null : key;
        draw();
        return;
      }

      // Case + case: a design picked for the second case.
      var design = event.target.closest('[data-kp-bundles-design]');
      if (design) {
        var wanted = design.getAttribute('data-kp-bundles-design');
        loadDesigns().then(function (list) {
          var picked = list.filter(function (entry) {
            return entry.handle === wanted;
          })[0];
          if (!picked) return;
          state.pair.product = picked;
          state.pair.key = '';
          state.editing = null;
          update(true);
        });
        return;
      }

      // Case + case: open the phone and case type choice for the second case, or go back to
      // matching the first case.
      var pairOpts = event.target.closest('[data-kp-bundles-pairopts]');
      if (pairOpts) {
        var reset = pairOpts.getAttribute('data-kp-bundles-pairopts') === 'reset';
        state.pair.more = !reset;
        if (reset) {
          state.pair.type = '';
          state.pair.model = '';
          state.pair.key = '';
          update(true);
        } else {
          draw();
        }
        return;
      }

      // Case + case: the second case's case type.
      var pairType = event.target.closest('[data-kp-bundles-pairtype]');
      if (pairType) {
        state.pair.type = pairType.getAttribute('data-kp-bundles-pairtype');
        state.pair.key = '';
        update(true);
        return;
      }

      // Case + case: more designs in the grid.
      if (event.target.closest('[data-kp-bundles-pairmore]')) {
        state.pair.shown += 48;
        var box = event.target.closest('.kp-bundles__pair');
        loadDesigns().then(function (list) {
          fillGrid(box, list);
        });
        return;
      }

      // Build your own: tick or untick an item.
      var toggle = event.target.closest('[data-kp-bundles-toggle]');
      if (toggle) {
        var item = toggle.getAttribute('data-kp-bundles-toggle');
        state.checks[item] = !state.checks[item];
        state.editing = null;
        update(true);
        return;
      }

      var head = event.target.closest('[data-kp-bundles-choose]');
      if (head) {
        state.selected = head.getAttribute('data-kp-bundles-choose');
        state.editing = null;
        draw();
        return;
      }

      if (event.target.closest('.kp-bundles__add')) add();
    }

    root.addEventListener('click', onClick);
    pairBox.addEventListener('click', onClick);

    // Case + case: typing in the design search filters the grid where it is, so the box
    // keeps the cursor.
    function onInput(event) {
      if (!event.target.matches || !event.target.matches('[data-kp-bundles-pairsearch]')) return;
      state.pair.query = event.target.value;
      state.pair.shown = 24;
      var box = event.target.closest('.kp-bundles__pair');
      loadDesigns().then(function (list) {
        fillGrid(box, list);
      });
    }

    root.addEventListener('input', onInput);
    pairBox.addEventListener('input', onInput);

    function onChange(event) {
      if (!event.target.matches) return;

      if (event.target.matches('[data-kp-bundles-pairmodel]')) {
        // Case + case: the second case's phone. The same phone as the page counts as no choice.
        var chosenModel = event.target.value;
        state.pair.model = chosenModel === choicesOf(wrapper)['Model'] ? '' : chosenModel;
        state.pair.key = '';
        update(true);
        return;
      }

      if (event.target.matches('[data-kp-bundles-set]')) {
        // Model or case type: handed to the page's picker; the list follows from there.
        state.editing = null;
        setChoice(event.target.getAttribute('data-kp-bundles-set'), event.target.value);
        return;
      }

      if (!event.target.matches('[data-kp-bundles-pick]')) return;
      state.picks[event.target.getAttribute('data-kp-bundles-pick')] = event.target.value;
      state.editing = null;
      update(true);
    }

    root.addEventListener('change', onChange);
    pairBox.addEventListener('change', onChange);

    var timer = null;
    var again = function () {
      window.clearTimeout(timer);
      timer = window.setTimeout(function () {
        update(false);
      }, 60);
    };

    // The theme re-draws the picker after every change, and our picker sets the selects.
    wrapper.addEventListener('change', again);
    if (window.MutationObserver) new MutationObserver(again).observe(wrapper, { childList: true, subtree: true });

    place();
    setMode('product');

    // Straight away (see waiting() above): the tabs and the outline, and the "Add a 2nd
    // case" line while a Case + case bundle is on offer (its price is added once known).
    // They are only taken away again if no bundle turns out to be possible for this case.
    bar.hidden = false;
    nudgeBox.hidden = !hasPair;
    if (hasPair) nudgeSub.textContent = 'Any design';
    frame();
    blocks.classList.add('kp-bundles-ready');

    loadShared(handle).then(function (shared) {
      state.shared = shared;
      update(true);
    });
  }

  // Case + case: the second case's picker.
  var pairStyle = document.createElement('style');
  pairStyle.textContent =
    '.kp-bundles__more.kp-bundles__more--word{flex:0 0 auto;width:auto;min-width:0;max-width:none;height:auto;padding:6px 4px;font-size:13px;font-weight:600;text-decoration:underline;letter-spacing:0 !important;text-transform:none}' +
    '.kp-bundles__half{display:inline-block;margin-left:4px;padding:1px 6px;border-radius:999px;background:#e8604c;color:#fff;font-size:10.5px;font-weight:700;vertical-align:middle}' +
    '.kp-bundles__note--warn{color:#b3261e}' +
    '.kp-bundles__pairbox{display:block}' +
    // The 2nd case's phone and case type: one line saying what it is, then (when opened) a
    // full-width phone dropdown and a three-way switch, the same height as the search box,
    // with even 10px gaps between them (16 Oct 2026, Sana: "looks messy").
    '.kp-bundles__pair-head{display:flex;align-items:baseline;justify-content:space-between;gap:10px;margin:0 0 10px;font-size:13px;line-height:1.35;color:#555}' +
    '.kp-bundles__pair-for strong{color:#111;font-weight:600}' +
    '.kp-bundles .kp-bundles__pair-toggle{flex:0 0 auto;margin:0;padding:0;min-height:0;border:0;background:none;color:#111;font:inherit;font-size:13px;font-weight:600;letter-spacing:0;text-transform:none;text-decoration:underline;text-underline-offset:2px;white-space:nowrap;cursor:pointer}' +
    '.kp-bundles__pair-opts{display:flex;flex-direction:column;gap:10px;margin:0 0 10px}' +
    '.kp-bundles .kp-bundles__pair-model{display:block;box-sizing:border-box;width:100%;max-width:none;height:44px;min-height:0;margin:0;padding:0 36px 0 12px;border:1.5px solid #ddd5cb;border-radius:10px;background:#fff url(\"data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 viewBox=%270 0 24 24%27 fill=%27none%27%3E%3Cpath d=%27M6 9l6 6 6-6%27 stroke=%27%23111%27 stroke-width=%272%27/%3E%3C/svg%3E\") no-repeat right 12px center/16px;color:#111;font:inherit;font-size:16px;line-height:normal;-webkit-appearance:none;appearance:none}' +
    '.kp-bundles-nudge-box{padding-bottom:10px}' +
    '.kp-bundles-nudge-box[hidden],.kp-bundle-mode .kp-bundles-nudge-box{display:none !important}' +
    '.kp-bundles-nudge{display:flex;align-items:center;gap:10px;box-sizing:border-box;width:100%;margin:0;padding:11px 14px;border:1.5px dashed #e8604c;border-radius:12px;background:#fff6f3;color:#111;font:inherit;text-align:left;cursor:pointer}' +
    '.kp-bundles-nudge__text{flex:1 1 auto;display:flex;flex-direction:column;gap:2px}' +
    '.kp-bundles-nudge__text strong{font-size:14px}' +
    '.kp-bundles-nudge__sub{font-size:12.5px;color:#6b6b6b}' +
    '.kp-bundles-nudge__arrow{font-size:18px;line-height:1;color:#e8604c}' +
    '.kp-bundles__pair{margin:8px 0 4px;padding:12px;border-radius:12px;background:#faf7f3}' +
    '.kp-bundles__pair-types{display:flex;box-sizing:border-box;height:44px;padding:3px;border:1.5px solid #ddd5cb;border-radius:10px;background:#fff}' +
    '.kp-bundles .kp-bundles__pair-type{flex:1 1 0;min-width:0;height:auto;min-height:0;margin:0;padding:0 4px;border:0;border-radius:7px;background:none;color:#111;font:inherit;font-size:14px;font-weight:600;line-height:1;letter-spacing:0;text-transform:none;white-space:nowrap;cursor:pointer}' +
    '.kp-bundles .kp-bundles__pair-type.is-on{background:#111;color:#fff}' +
    '.kp-bundles__pair-search{display:block;box-sizing:border-box;width:100%;height:44px;margin-bottom:10px;padding:0 12px;border:1.5px solid #ddd5cb;border-radius:10px;background:#fff;font:inherit;font-size:16px}' +
    '.kp-bundles__pair-grid{display:grid;grid-template-columns:repeat(4,minmax(0,1fr));gap:8px;max-height:420px;overflow-y:auto}' +
    '@media (max-width:749px){.kp-bundles__pair-grid{grid-template-columns:repeat(3,minmax(0,1fr))}}' +
    '.kp-bundles__pair-tile{display:flex;flex-direction:column;align-items:center;gap:4px;padding:6px;border:1.5px solid transparent;border-radius:10px;background:#fff;color:#111;font:inherit;cursor:pointer}' +
    '.kp-bundles__pair-tile.is-on{border-color:#111}' +
    '.kp-bundles__pair-image{display:block;width:100%;height:auto;aspect-ratio:1;object-fit:contain}' +
    '.kp-bundles__pair-name{font-size:11.5px;line-height:1.25;text-align:center}' +
    '.kp-bundles__pair-more{display:block;width:100%;margin-top:10px;padding:9px;border:1.5px solid #111;border-radius:999px;background:#fff;color:#111;font:inherit;font-size:13px;font-weight:600;cursor:pointer}' +
    '.kp-bundles__pair-empty{grid-column:1/-1;margin:8px 0;font-size:13px;color:#6b6b6b;text-align:center}' +
    // The 2nd case picker under Add to Cart.
    '.kp-bundles-pairbox{margin-top:10px}' +
    '.kp-bundles-pairbox[hidden]{display:none}' +
    '.kp-bundles-pairbox .kp-bundles__items{padding:12px;border:1px solid #e7dfd6;border-radius:12px;background:#fff}' +
    '.kp-bundles-pairbox .kp-bundles__add{margin-top:10px}' +
    '.kp-bundles-nudge__arrow{transition:transform .2s ease}' +
    '.kp-bundles-nudge.is-open .kp-bundles-nudge__arrow{transform:rotate(90deg)}';
  document.head.appendChild(pairStyle);

  function initAll() {
    each(document.querySelectorAll('.product__variants-wrapper'), start);
    // Pages (or parts) where no tabs were put: let the space held for them go (see part 14
    // of snippets/kp-extras.liquid).
    each(document.querySelectorAll('.product-blocks'), function (node) {
      node.classList.add('kp-bundles-ready');
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', initAll);
})();
